const TOKEN_KEY = 'boat_partner_token'

export function getPartnerToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setPartnerToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removePartnerToken() {
  localStorage.removeItem(TOKEN_KEY)
}
